<div #outsideModal class="modal" [style.display]="isMail ? 'none' : 'block'" [ngStyle]="printDirectly ? {'top': '-9000px', 'position': 'absolute'} : {}">
  <div #modalBody class="modal-content" [class.a4]="this.ordonnance && this.ordonnance.isEprescription">
    <div class="modal-header">{{ getTitle() }}</div>
    <div class="modal-body">
      <div class="top-part">
        <div class="button-wrapper">
          <div (click)="askNextDocument(AskNextDocument.Previous)" title="Document précédent" class="navigation-button left" *ngIf="isPreviousDocument">
            <img src="assets/icons/chevron-bottom-darkest-primary.svg">
          </div>
          <ng-container *ngIf="!!ordonnance && ordonnance.isEprescription && !ordonnance.ePrescription && !retryEprescription">
            <frg-button backgroundColor="var(--primary)" (activated)="continueEprescription()">
              <div title="Continuer">Continuer</div>
            </frg-button>
          </ng-container>
          <ng-container *ngIf="!!ordonnance && ordonnance.isEprescription && ordonnance.ePrescription && !retryEprescription">
            <!-- <frg-button *ngIf="!loading && !ePduplicationNumber" (activated)="dupliquerEp()" backgroundColor="var(--danger)">
              <div title="Duplique">Dupliquer ePrescription</div>
            </frg-button> -->
            <frg-button *ngIf="!loading && (canDownloadDocument() || canPrintDocument())" backgroundColor="var(--darkest-primary)" (activated)="printDocument()" [disabled]="!canPrintDocument()">
              <div title="Imprimer le document">Imprimer</div>
            </frg-button>
          </ng-container>
          <ng-container *ngIf="!!ordonnance && ordonnance.isEprescription && !ordonnance.ePrescription && retryEprescription">
            <frg-button backgroundColor="var(--danger)" (activated)="continueEprescription()">
              <div title="Reesayer">Réessayer ePrescription</div>
            </frg-button>
            <frg-button *ngIf="!loading && (canDownloadDocument() || canPrintDocument())" backgroundColor="var(--darkest-primary)" (activated)="printDocument()" [disabled]="!canPrintDocument()">
              <div title="Imprimer le document">Imprimer</div>
            </frg-button>
          </ng-container>
          <ng-container *ngIf="!ordonnance || !ordonnance.isEprescription">
            <frg-button *ngIf="!loading && canSendDocument()" backgroundColor="var(--darkest-primary)" (activated)="sendDocument()" [disabled]="!canSendDocument()">
              <div title="Envoyer">Mail sécurisé</div>
            </frg-button>
            <frg-button *ngIf="!loading && canSendDocument()" backgroundColor="var(--darkest-primary)" (activated)="sendDocument()" [disabled]="!canSendDocument()">
              <div title="Envoyer">Envoyer via Apicrypt</div>
            </frg-button>
            <frg-button *ngIf="!loading && canDownloadDocument()" backgroundColor="var(--darkest-primary)" (activated)="downloadDocument()" [disabled]="!canDownloadDocument()">
              <div title="Téléchager le document">Télécharger</div>
            </frg-button>
            <frg-button *ngIf="!loading && (canDownloadDocument() || canPrintDocument())" backgroundColor="var(--darkest-primary)" (activated)="printDocument()" [disabled]="!canPrintDocument()">
              <div title="Imprimer le document">Imprimer</div>
            </frg-button>
            <div (click)="askNextDocument(AskNextDocument.Next)" title="Document suivant" class="navigation-button right" *ngIf="isNextDocument">
              <img src="assets/icons/chevron-bottom-darkest-primary.svg">
            </div>
          </ng-container>
        </div>
        <div class="duplicate" *ngIf="!!ePduplicationNumber">e-Prescription dupliquée de {{ePduplicationNumber}}</div>
      </div>
      <div class="content-wrapper">
        <ng-template #viewerContainer></ng-template>
        <div class="content-loader" *ngIf="loading">
          <div class="loading-txt">Chargement de l'affichage du document...</div>
          <div class="lds-spinner"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
        </div>
      </div>
      <div class="annexes-info-section" *ngIf="document?.annexes && document.annexes.length > 0">
        <div class="annexes-info-header">
          <mat-icon class="info-icon">info</mat-icon>
          <div class="annexes-info-message">
            <strong>{{ document.annexes.length }} pièce(s) jointe(s)</strong> {{ document.annexes.length === 1 ? 'sera incluse' : 'seront incluses' }} lors de la prochaine étape d'impression.
          </div>
        </div>
        
        <div class="annexes-list">
          <div class="annexe-item" *ngFor="let annexe of document.annexes">
            <mat-icon class="annexe-icon">attach_file</mat-icon>
            <div class="annexe-name">{{ annexe.fileName }}</div>
          </div>
        </div>
      </div>
      <div class="close-button-wrapper">
        <frg-button backgroundColor="var(--darkest-primary)" (activated)="closeModal()">
          <div title="Fermer le visualiseur">Fermer</div>
        </frg-button>
      </div>
    </div>
  </div>
</div>
<div [style.display]="isMail ? 'none' : 'block'" class="modal-background"></div>
